import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { notification } from "antd";

export const albumSlice = createSlice({
  name: "album",
  initialState: {
    albumList: [],
    album: null,
  },
  reducers: {
    setAlbumList: (state, action) => {
      state.albumList = action.payload;
    },

    setAlbum: (state, action) => {
      state.album = action.payload;
    },

    deleteAlbum: (state, action) => {
      const id = action.payload;

      state.albumList = state.albumList.filter((x) => x.id !== id);

      if (state.album && state.album.id === id) {
        state.album = null;
      }
    },

    deleteMedia: (state, action) => {
      const { albumId, mediaId } = action.payload;

      const albumIndex = state.albumList.findIndex((x) => x.id === albumId);

      if (albumIndex !== -1) {
        state.albumLIst[albumIndex].media = state.albumLIst[
          albumIndex
        ].media.filter((m) => m.id !== mediaId);
      }
    },

    toggleAlbum: (state, action) => {
      const id = action.payload;

      let fAlbum = state.albumList.find((x) => x.id === id);
      if (fAlbum) {
        fAlbum.isPublished = !fAlbum.isPublished;
      }

      if (state.album && state.album.id === id) {
        state.album.isPublished = !state.album.isPublished;
      }
    },

    updateAlbum: (state, action) => {
      const { id, title, description } = action.payload;

      let album = state.albumList.find((x) => x.id === id);
      if (album) {
        album.title = title;
        album.description = description;
      }

      if (state.album && state.album.id === id) {
        state.album.title = title;
        state.album.description = title;
      }
    },
  },
});

export const {
  setAlbumList,
  setAlbum,
  deleteAlbum,
  toggleAlbum,
  updateAlbum,
  deleteMedia,
} = albumSlice.actions;

export const selectAlbums = (state) => state.album.albumList;
export const selectAlbum = (state) => state.album.album;

export default albumSlice.reducer;

export const getAlbumList = (pageNumber, pageSize, callback) => (dispatch) => {
  axios
    .get("album/getList", {
      params: {
        pageNumber,
        pageSize,
      },
    })
    .then(({ data }) => {
      dispatch(setAlbumList(data.albums));
      callback && callback(data.totalCount);
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const getAlbum = (albumId, callback) => (dispatch) => {
  axios
    .get(`album/${albumId}`)
    .then(({ data }) => {
      dispatch(setAlbum(data));
      callback && callback(data);
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const deleteAlbumById = (id, callback) => (dispatch) => {
  axios
    .delete(`album/${id}`)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(deleteAlbum(id));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const deleteMediaById =
  ({ albumId, mediaId }, callback) =>
  (dispatch) => {
    axios
      .delete(`album/media/${mediaId}`)
      .then(({ data }) => {
        notification.success({ message: data.message });
        dispatch(deleteMedia(albumId, mediaId));
        callback && callback();
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
        callback && callback();
      });
  };

export const toggleAlbumById = (id, callback) => (dispatch) => {
  axios
    .patch(`album/togglePublish/${id}`)
    .then(({ data }) => {
      console.log(data);
      notification.success({ message: data.message });
      dispatch(toggleAlbum(id));
      callback && callback();
    })
    .catch((error) => {
      console.log(error);
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const createAlbum = (values, callback) => (dispatch) => {
  axios
    .post("album/create", values)
    .then(({ data }) => {
      notification.success({ message: data.message });
      callback && callback(data);
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};

export const updateAlbumById = (id, albumData, callback) => (dispatch) => {
  axios
    .put(`album/${id}`, albumData)
    .then(({ data }) => {
      notification.success({ message: data.message });
      dispatch(updateAlbum(albumData));
      callback && callback();
    })
    .catch((error) => {
      notification.error({ message: error.response.data.message });
      callback && callback();
    });
};
